Dropzone.autoDiscover = false;
var $infScroll=null;



APP = {
    common: {

        commentHtml: function(comment,el) {
            $(el).append('<div class="comment-'+comment.type+' col-sm-6 col-md-3">'+
                    '<a href="#" data-toggle="modal" data-target="#myModal">'+
                        '<div class="blog-card">'+
                        '<div class="bkg" style="background-image:url('+comment.image+')"></div>'+
                        '<span class="icon-'+comment.type+'-camera"></span>'+
                            '<div class="title-content">'+
                                '<div class="intro">'+comment.short+'</div>'+
                            '</div>'+
                            '<div class="card-info">'+comment.long+'</div>'+
                            '<div class="utility-info">'+
                                '<ul class="utility-list">'+
                                    '<li class="date"><i class="icon-calendar"></i>'+comment.created_at+'</li>'+
                                '</ul>'+
                            '</div>'+
                            '<div class="data" style="display:none;">'+
                            '<div class="quote">'+comment.comment+'</div><div class="video">'+comment.mediaVideo+'</div><div class="image">'+comment.mediaImage+'</div><div class="name">'+comment.name+'</div>'+
                            '</div>'+
                            '<div class="gradient-overlay"></div>'+
                            '<div class="color-overlay"></div>'+
                        '</div>'+
                    '</a>'+
                '</div>'


            );
        },
        loadComments: function (url) {

            $.ajax({
                url: url,
                success: function(comments) {
                    if (comments.total > 0) {
                        $('#comments').fadeIn();
                    }
                        var el= $('#comments .list-of');
                        for (var i = 0; i < comments.comments.length; i++) {
                            APP.common.commentHtml(comments.comments[i],el);
                        }
                        if (comments.next) {
                            var $next = $("#comments .control").find('.next');

                            $next.show().attr('href',comments.next);

                            var $infScroll = $('.infinite-scroll').infiniteScroll({
                                path: function () { return $next.attr('href'); },
                                responseType: 'text',
                                history: false,
                                debug: true,
                                status: '.page-load-status',
                            });

                            $infScroll.on( 'load.infiniteScroll', function( event, response ) {
                              // prase response text into JSON data
                                response = JSON.parse( response );
                                console.log(response);
                                for (var i = 0; i < response.comments.length; i++) {
                                    $next.attr('href',response.next);
                                    APP.common.commentHtml(response.comments[i],el);
                                }
                            });
                        }
                }
            });

        },
        loadInfo: function (id,customURL) {
            $(".map-info").attr('data-id', id);
            $("#map > .content").removeClass('info-hidden');
            $(".map-info").html('');
            $(".map-info").load(customURL);
            window.history.pushState(null, "Atemp", customURL);
            APP.common.loadComments(customURL+"/comentarios");
            if($infScroll) { $infScroll.destroy(); }
        },
        loadMap: function () {
            if ( $('body').attr('data-schoolid') >= 1) {
                id= $('body').attr('data-schoolid');
                slug= $('body').attr('data-schoolslug');
                APP.common.loadInfo(id,window.location.protocol+'//'+window.location.hostname+'/escola/'+id+'/'+slug);
            }
            function setMarkers(map) {
                var image = {
                    url: 'http://observatorio.atempa.org.br/img/pin.png',
                    size: new google.maps.Size(20, 32),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(0, 32)
                };
                var shape = {
                    coords: [1, 1, 1, 20, 18, 20, 18, 1],
                    type: 'poly'
                };
                $.ajax({
                    url: "/escolas/map",
                    success: function(schools) {
                        // var schools = result;
                        for (var i = 0; i < schools.length; i++) {
                            var school = schools[i];
                            var marker = new google.maps.Marker({
                                position: {lat: school[1], lng: school[2]},
                                map: map,
                                icon: image,
                                shape: shape,
                                title: school[0],
                                zIndex: school[3],
                                customURL: '/escola/'+school[3]+'/'+school[4],
                                customId: school[3],

                            });
                            google.maps.event.addListener(marker, 'click', function() {
                                if ( $(".map-info").attr('data-id') == this.customId) {
                                    // $(".map-info").load(this.customId);
                                } else {
                                    APP.common.loadInfo(this.customId,this.customURL);
                                }
                                map.setCenter(this.getPosition());
                                map.setZoom(15);


                                 // map.setCenter({lat: this.posLat, lng: this.posLng});
                                // console.log(new google.maps.LatLng(marker.getPosition().lat(),marker.getPosition().lng()));
                                // map.setCenter(new google.maps.LatLng(marker.getPosition().lat(),marker.getPosition().lng()));

                            });
                            var infowindow = new google.maps.InfoWindow();
                            google.maps.event.addListener(marker, 'mouseover', function() {
                                infowindow.setContent(this.title);
                                infowindow.open(map,this);
                            });
                            google.maps.event.addListener(marker, 'mouseout', function() {
                                infowindow.close();

                            });
                        }
                    }
                });
            }
            function initMap() {
                var map = new google.maps.Map(document.getElementById('map-custom'), {
                zoom: 12,
                center: {lat: -30.073044395261693, lng: -51.18233820602455}
                });

                setMarkers(map);
            }

            initMap();
            // var schools = {!! $escolas !!};
            $("#myModal").on("show.bs.hidden", function() {
                $(this).find(".image").empty();
                $(this).find(".video").empty();
                $(this).find(".quote").empty();
                $(this).find(".name").empty();
            });
            $("#myModal").on("show.bs.modal", function(e) {
                var $e = $(e.relatedTarget);

                $(this).find(".quote").html($e.find('.quote').html());

                if ($e.find('.image').html().length > 10) {
                    $(this).find(".image").html("<img src='"+$e.find('.image').html()+"'/>");
                }
                if ($e.find('.video').html().length > 10) {
                    $(this).find(".video").html('<div id="embed-video"><div class="embed-video-item"><div class="embed-responsive embed-responsive-16by9"><iframe src="'+$e.find('.video').html()+'?wmode=transparent&amp;autoplay=0&amp;loop=0" type="" allowfullscreen="" class="embed-responsive-item" frameborder="0"></iframe></div></div></div>');
                }
                if ($e.find('.name').html().length > 2) {
                    $(this).find(".name").html("<h3 class='text-right'>"+$e.find('.name').html()+"</h3>");
                }


            });

        },

        commentsForm: function () {

            APP.common.upload();
            $(".map-info").on('click','.clear-video', function () {
                $('.map-info').find('input[name="video"]').val("");
                $(".map-info").find('.embed-responsive').remove();
                $('.map-info').find('.btn-foto').prop("disabled",false);

            });
            $(".map-info").on('click','button[data-target="#commentsMediaVideo"]', function() {
                $("#commentsMediaFoto").animate({height:0},500,function() { $(this).removeClass('in').removeAttr('style');});
            });

            $(".map-info").on('click','button[data-target="#commentsMediaFoto"]', function() {
                $("#commentsMediaVideo").animate({height:0},500,function() { $(this).removeClass('in').removeAttr('style'); });
            });

            $('.map-info').on('change','input[name="video"]', function() {
                var url_video = $(this).val();
                $.ajax({
                    url: "/escola/comentarios/video",
                    data: { url: url_video },
                    type : 'post',

                    beforeSend: function() {
                        $("#embed-video").html('carregando vídeo...');
                    },
                    success: function(result){
                        $("#embed-video").html("<div class='embed-video-item'>"+result+"</div>");
                        if ($(".map-info").find('.embed-responsive').length > 0) {
                            $(".map-info").find('.dz-preview').remove();
                            $('.map-info').find('.btn-foto').prop("disabled",true);
                        }
                    }
                });
            });
        },

        upload: function() {
            if (typeof drop !== 'undefined' ) {
                drop.destroy();
            }
            $('.dropzone-preview').find('.dz-remove').unbind('click').on('click',function () {
                $(this).parent().remove();
            });
            if ( $('.file-upload') ) {
                $('.file-upload').each(function () {
                    var upload = {
                        url: $(this).data('url'),
                        folder: 'comments',
                        input: $(this).data('input'),
                        maxFiles: 1,
                        acceptedFiles: "image/*",
                    };

                    var el = this;

                    var drop = new Dropzone(el, {
                        createImageThumbnails: true,
                        addRemoveLinks: true,
                        url: upload.url,
                        uploadMultiple: false,
                        maxFiles: upload.maxFiles,
                        acceptedFiles: upload.acceptedFiles,
                        headers: {
                           'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
                        },
                        init: function() {
                            var myDropzone = this;
                            var myDropzoneAttr = upload;
                            this.on("sending", function(file, xhr, formData) {
                                // console.log(formData);
                                formData.append("folder", myDropzoneAttr.folder);
                            });
                            this.on("removedfile", function(file) {
                                // console.log(upload.url+"/remove/?file="+$(file.previewElement).attr('data-sfile'));
                                $.get(upload.url+"/remove/?file="+$(file.previewElement).attr('data-sfile'));
                                $('.map-info').find('.btn-video').prop("disabled",false);

                            });
                            this.on("success", function( file, response ){
                                if(myDropzone.options.maxFiles == 1) {
                                    $(myDropzone.element).next().empty();
                                }
                                $(file.previewElement).append("<input type='hidden' name='"+myDropzoneAttr.input+"[]' value='"+response.file+"'/>");
                                $(file.previewElement).attr('data-sfile',response.file);

                                $('.map-info').find('.btn-video').prop("disabled",true);
                                $(".map-info").find('input[name="video"]').val("");
                                $(".map-info").find('.embed-responsive').remove();
                            });
                            this.on("addedfile", function (file) {
                            });
                            this.on("maxfilesexceeded", function(file) {
                                this.removeAllFiles();
                                this.addFile(file);
                            });
                        }
                    });
                });
            }
        },
        init: function () {
            APP.common.commentsForm();
            APP.common.loadMap();
            $('.map-info').on("submit","form", function(event){
                event.preventDefault();
                var form = $(this);
                $.ajax({
                    type: "POST",
                    url: "/escola/comentarios/salvar",
                    data: form.serialize(),
                    dataType: 'json',
                    beforeSend: function() {
                        $(form).addClass('sending');
                    },
                    success: function(data)
                    {
                        $(form).removeClass('sending');
                        if (data.errors) {
                            $('form .status').html('<div class="alert alert-danger" role="alert">O Formulário não foi enviado.</div>');
                            if (data.errors[0]) {
                                $('form .status').children('.alert').append("<br/>"+data.errors[0]+".");
                            }
                            if (data.errors[1]) {
                                $('form .status').children('.alert').append("<br/>"+data.errors[1]+".");
                            }
                        }
                        else {
                            if( data.success) {
                                $('form .status').empty();

                                $('form .status').html('<div class="alert alert-success" role="alert">'+data.message+'</div>');

                                $(".map-info").find('input[name="video"]').val("");
                                $(".map-info").find('input[name="name"]').val("");
                                $(".map-info").find('textarea[name="comment"]').val("");
                                $(".map-info").find('.embed-responsive').remove();
                                $(".map-info").find('.dz-preview').remove();
                                $('.map-info').find('.btn-foto').prop("disabled",false);
                                $('.map-info').find('.btn-video').prop("disabled",false);
                            }
                            else {
                                $('form .status').html('<div class="alert alert-danger" role="alert">O Formulário não foi enviado.</div>');

                            }
                        }
                    },
                });
            });
        }
    },
};

UTIL = {
    exec: function (controller, action) {
        var namespace = APP;
        action = (action === undefined) ? "init" : action;

        if (controller !== "" && namespace[controller] && typeof namespace[controller][action] == "function") {
            namespace[controller][action]();
        }
    },

    init: function () {
        var body = document.body;
        var controller = body.getAttribute("data-controller");
        var action = body.getAttribute("data-action");

        UTIL.exec("common");
        UTIL.exec(controller);
        UTIL.exec(controller, action);
    }
};
$( window ).on( "load", UTIL.init );
// $(document).load(UTIL.init);

function createDropZone() {
    APP.common.upload();
}
